import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SearchBranchList } from "../../../model/branch/BranchListModel";

interface SettingsChangeDefaultBranchInterface {
  branchDetail?: SearchBranchList | null;
}

const initialState: SettingsChangeDefaultBranchInterface = {
  branchDetail: null,
};

const settingsChangeDefaultBranch = createSlice({
  name: "settingsChangeDefaultBranch",
  initialState,
  reducers: {
    applyChoosenDefaultBranch: (
      state,
      action: PayloadAction<SettingsChangeDefaultBranchInterface>
    ) => {
      state.branchDetail = action.payload.branchDetail;
    },
  },
});

export const { applyChoosenDefaultBranch } = settingsChangeDefaultBranch.actions;
export default settingsChangeDefaultBranch.reducer;
